import { DocumentRequestEventNameEnum } from '../enums/document-request-event-name.enum';
import { UserRoleEnum } from '../../user/enums/user-role.enum';

export enum RequestSourceEnum {
  MANAGER = 'MANAGER',
  DRIVER = 'DRIVER',
}

export interface IDocumentRequestEvent {
  eventName: DocumentRequestEventNameEnum;
  candidateUserId: string;
  documentRequestId: string;
  candidateDocumentId?: string;
  triggeredByUserId?: string;
  triggeredByUserRole?: UserRoleEnum;
  detailsMessage?: string;

  documentName?: string;
  triggeredByUserName?: string;
  candidateUserName?: string;
  eventDate?: string;
  source?: RequestSourceEnum;
}
